import type { EntityData } from '@adornis/baseql/entities/types.js';
import { DropdownSelectionInput } from '@adornis/formfield/fields/dropdown-selection-input.js';
import { TextInput } from '@adornis/formfield/fields/text-input.js';
import type { FunctionalForm } from '@adornis/forms/use-form.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { FormGridEntry } from '@martinus/styles/client/FormGridEntry.js';
import { html, nothing } from 'lit';
import type { Person } from '../../../entities/person.js';
import { Abrechnungsgruppe, PersonenGruppe } from '../../entities/employee-sections/an-beschaeftigung.js';

export const EmployeeSectionBeschaeftigungForm = stateful((props: { form: FunctionalForm<EntityData<Person>> }) => {
  if (!props.form.document) return nothing;
  return html`
    <div class="form-grid">
      ${FormGridEntry({
        label: 'Arbeitnehmertyp',
        render: TextInput({
          ...props.form.field('mitarbeiterDaten', 'anBeschaeftigung', 'employeeType'),
          placeholder: 'Kein Arbeitnehmertyp hinterlegt',
          placeholderMode: 'hide',
          clearable: true,
        }),
      })}
      ${FormGridEntry({
        label: 'Personengruppe',
        render: DropdownSelectionInput({
          ...props.form.field('mitarbeiterDaten', 'anBeschaeftigung', 'personenGruppe'),
          placeholder: 'Keine Personengruppe hinterlegt',
          placeholderMode: 'hide',
          selectables: Object.keys(PersonenGruppe).map(x => +x),
          renderString: (key: number | null) =>
            key ? `${key} - ${(PersonenGruppe as Record<number, string>)[key] ?? 'Ungültige Angabe'}` : 'Keine Angabe',
          clearable: true,
        }),
      })}
      ${FormGridEntry({
        label: 'Abrechnungsgruppe',
        render: DropdownSelectionInput({
          ...props.form.field('mitarbeiterDaten', 'anBeschaeftigung', 'abrechnungsgruppe'),
          placeholder: 'Keine Abrechnungsgruppe hinterlegt',
          placeholderMode: 'hide',
          selectables: Object.values(Abrechnungsgruppe),
          clearable: true,
        }),
      })}
      ${FormGridEntry({
        label: 'Fachrichtung',
        render: TextInput({
          ...props.form.field('mitarbeiterDaten', 'anBeschaeftigung', 'fachrichtung'),
          placeholder: 'Keine Fachrichtung hinterlegt',
          placeholderMode: 'hide',
          clearable: true,
        }),
      })}
    </div>
  `;
});
